import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import styles from './styles';

export interface Error {
  messages: [string];
  line: string;
}

type ErrorListProps =
  | {
      errors: Error[];
      title: string;
      getMessages: (code: string) => string | [string];
      customLine?: false;
    }
  | {
      errors: Error[];
      title: string;
      getMessages: (code: string) => string | [string];
      customLine: true;
      getCustomLine: (error: Error) => string;
    };
/**
 * @param props
 * @param props.errors
 * @param props.title A descriptive title of the error box
 * @param props.getMessages Key-value dictionary of error message translation ids
 * @param props.customLine Indicates whether to display a custom line instead of the default "line <number>"
 * @param props.getCustomLine Function to get the custom line
 */
const ErrorList = (props: ErrorListProps) => {
  const { t } = useTranslation();

  const { errors, getMessages } = props;
  const customLine = 'customLine' in props ? props.customLine : false;
  const getCustomLine = 'getCustomLine' in props ? props.getCustomLine : undefined;

  /**
   * Gets the text of the error message
   * @param code
   */
  function getText(code: string) {
    const message = getMessages(code);
    if (typeof message === 'string') {
      return t(message);
    } else if (Array.isArray(message)) {
      return t(...message);
    }

    return message;
  }

  return (
    <Box component={'ul'} sx={styles.box}>
      {errors?.map((error, key) => {
        return (
          <li key={key}>
            <Typography component='span' variant='h4'>
              {`${
                customLine
                  ? getCustomLine!(error)
                  : t('COMMON:FILE_UPLOADS:LINE_NUMBER', { number: error.line })
              }: `}
            </Typography>
            <Typography variant='body1'>{error.messages.map(getText).join('; ')}</Typography>
          </li>
        );
      })}
    </Box>
  );
};

export default ErrorList;
